import { docElement } from './docElement.js';

export function resetFakeBody (body, docOverflow) {
  if (body.fake) {
    body.remove();
    docElement.style.overflow = docOverflow;
    // Trigger layout so kinetic scrolling isn't disabled in iOS6+
    // eslint-disable-next-line
    docElement.offsetHeight;
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/tiny-slider/src/helpers/resetFakeBody.js
// module id = 10
// module chunks = 0